"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IcisLogo = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IcisLogo = _interopRequireDefault(require("./IcisLogo"));
// Intentionally kept separate from the MainNav.style.js file to avoid conflicts with the
// IcisLogo component in the shared-header-pilet authoring package
const IcisLogo = exports.IcisLogo = (0, _styledComponents.default)(_IcisLogo.default).withConfig({
  displayName: "IcisLogostyle__IcisLogo",
  componentId: "sc-gk1u7d-0"
})(["display:inline-block;margin-right:20px;margin-left:0;width:130px;@media only screen and (max-width:1199px){margin-right:5px;}"]);